import { envConfig } from './envs'

export const featureFlags = envConfig.featureFlags
export const CLIENT_REF_LIMIT = 34
